<div class="forward-settings">
  <h3 class="fs-heading">Forward to Quota & Cleanup Policies</h3>
  <p class="fs-description">
    Use this to assign the <strong>Quota &amp; Cleanup Policies</strong> step to a team and user
    who will complete quota and resource cleanup configuration for this class.
    The assignee will receive a notification with the class context.
  </p>
  <!-- Template gate banners — one per unready template; absent when class is confirmed -->
  <div *ngFor="let tpl of untestedTemplates" class="vm-gate-banner">
    <mat-icon class="gate-icon">warning_amber</mat-icon>
    <div class="gate-text">
      <strong>{{ tpl.label }} not ready.</strong>
      <span>Testing must be marked as done and confirm class on all templates before this class can be forwarded.</span>
    </div>
    <button mat-stroked-button class="gate-btn" (click)="navigateTo(tpl.type)">
      <mat-icon>{{ tpl.icon }}</mat-icon> Go to {{ tpl.label }}
    </button>
  </div>
  <!-- Success state -->
  <div *ngIf="submitSuccess" class="fs-success">
    <mat-icon>check_circle</mat-icon>
    <div>
      <strong>Forwarded successfully.</strong>
      <span>The Quota &amp; Cleanup Policies team has been notified. You can forward again if needed.</span>
    </div>
    <button mat-stroked-button (click)="submitSuccess = false">Forward Again</button>
  </div>

  <form *ngIf="!submitSuccess" [formGroup]="form" class="fs-form" (ngSubmit)="submit()">

    <!-- Team -->
    <mat-form-field appearance="outline" class="fs-field">
      <mat-label>Team</mat-label>
      <mat-select formControlName="team">
        <mat-option *ngIf="isLoadingTeams" disabled>Loading teams…</mat-option>
        <mat-option *ngFor="let t of teams" [value]="t.team">{{ t.team }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="!isLoadingTeams && teams.length === 0">
        No teams found for this step.
      </mat-hint>
      <mat-error *ngIf="form.get('team')?.hasError('required')">Team is required</mat-error>
    </mat-form-field>

    <!-- User -->
    <mat-form-field appearance="outline" class="fs-field">
      <mat-label>User</mat-label>
      <mat-select formControlName="user" [disabled]="!form.get('team')?.value">
        <mat-option *ngIf="!form.get('team')?.value" disabled>Select a team first</mat-option>
        <mat-option *ngFor="let u of users" [value]="u.name">{{ u.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('user')?.hasError('required')">User is required</mat-error>
    </mat-form-field>

    <!-- Remarks -->
    <mat-form-field appearance="outline" class="fs-field">
      <mat-label>Remarks</mat-label>
      <textarea matInput formControlName="remarks" rows="3"
        placeholder="Provide context for the assignee (e.g., subscription IDs to configure)"></textarea>
      <mat-error *ngIf="form.get('remarks')?.hasError('required')">Remarks are required</mat-error>
    </mat-form-field>

    <div class="fs-actions">
      <button mat-raised-button color="primary" type="submit" [disabled]="isSubmitting || isGated">
        <mat-spinner *ngIf="isSubmitting" diameter="18" class="btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!isSubmitting">forward</mat-icon>
        {{ isSubmitting ? 'Forwarding…' : 'Forward' }}
      </button>
    </div>

  </form>
</div>